/**
 * @file
 * Boolean property that is `true` if the application is rendering in right to left reading direction; `false`
 * otherwise.
 */


export default {
    get: function() {
        return this.$root.__app?.direction === 'rtl';
    }
}
